import { Component, Vue, Prop } from 'vue-property-decorator';
import icons from '../../../telstra-ui-resources/images/sprite.symbol.svg';

@Component
export default class SvgIcon extends Vue {

  @Prop() name!: string;
  @Prop() className!: string;

  render(): JSX.Element {
    return (
      <svg class={`${this.className || 'tl-default-svg-class'}`}><use xlinkHref={`${icons}#${this.name}`}></use></svg>
    );
  }
}
